import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    quoteQuestionPlainItemContainer: {
        marginBottom: theme.spacing[12]
    },
    title: {
        fontSize: theme.fontSize.sm
    },
    content: {
        overflowWrap: 'break-word',
        marginRight: theme.spacing[4],
        fontWeight: theme.fontWeight.semibold,
        fontSize: theme.fontSize.sm
    },
    optionalText: {
        display: 'inline-block',
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey600
    }
}));

const QuoteQuestionPlainItem = ({ title, content, titleOnlyMode, optional }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const symbol = titleOnlyMode ? '.' : ':';

    return (
        (!content && !titleOnlyMode) ? null
            : (
                <div className={classes.quoteQuestionPlainItemContainer}>
                    <Typography className={classes.title}>
                        {`${title}${symbol} `}
                        {
                            !titleOnlyMode && (
                                <Typography component="span" className={classes.content}>
                                    {content}
                                    { optional
                                    && <Typography component={'span'} className={classes.optionalText}>{'(OPTIONAL)'}</Typography>}
                                </Typography>
                            )
                        }
                    </Typography>
                </div>
            )
    );
};

QuoteQuestionPlainItem.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.node,
    titleOnlyMode: PropTypes.bool,
    optional: PropTypes.bool
};

export { QuoteQuestionPlainItem };
